export default "__VITE_ASSET__GntKI$OG__"